import React from "react";
import * as R from "ramda";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import ToggleButton from "react-toggle-button";
import { mapToObjectDDL } from "../../../common/mapper";

export const formGroup = {
  coaId: { value: "" },
  coaName: { value: "", mandatory: true },
  masterCoaDetailDTOS: { value: [] },
  masterCoaCabangDTOS: { value: [] },
  status: { value: "ACTIVE" },
};

export const initialDataDetail = {
  transactionType: null,
  category: null,
  subGroup: null,
  group: null,
  status: "ACTIVE",
  saved: false,
  isNew: true,
};

export const tableColumns = {
  mainPage: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;
          return <span>{rowNumber}</span>;
        },
        sort: false,
      },
    },
    {
      name: "coaId",
      label: "ID COA",
    },
    {
      name: "coaName",
      label: "Nama COA",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "cabangNames",
      label: "Cabang Berlaku",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
  ],
  detailPage: (
    handleSaveRow,
    handleEditRow,
    handleCancelRow,
    handleDeleteRow,
    handleValueChange,
    handleToggleClick,
    handleCategoryChange,
    handleItemChange,
    dataSubgoup,
    dataGroup,
    dataKategori,
    dataItem,
    tab
  ) => {
    return [
      ...defaultDetailColumns(
        "coaDetailId",
        "transactionType",
        "category",
        "subGroup",
        "group",
        handleSaveRow,
        handleEditRow,
        handleCancelRow,
        handleDeleteRow,
        handleValueChange,
        handleToggleClick,
        handleCategoryChange,
        handleItemChange,
        dataSubgoup,
        dataGroup,
        dataKategori,
        dataItem,
        tab
      ),
    ];
  },
};

const defaultDetailColumns = (
  coaDetailId,
  transactionType,
  category,
  subGroup,
  group,
  handleSaveRow,
  handleEditRow,
  handleCancelRow,
  handleDeleteRow,
  handleValueChange,
  handleToggleClick,
  handleCategoryChange,
  handleItemChange,
  dataSubgoup,
  dataGroup,
  dataKategori,
  dataItem,
  tab
) => {
  return [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (value, tableMeta) => {
                return <>{tableMeta.rowIndex + 1}</>;
            },
            sort: false,
        },
    },
    {
      name: "coaDetailId",
      label: "ID Jenis Transaksi",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "transactionType",
      label: "Jenis Transaksi*",
      options: {
        customBodyRender: (val, tableMeta) => {
          const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
          return (
            <SimpleInput
              id="input_text_jenis_Transaksi"
              name="transactionType"
              readOnly={isSaved}
              containerclassname="margin-bottom-none"
              value={val}
              onChange={({ target }) =>
                handleValueChange(tableMeta.rowIndex, target.name, target.value)
              }
            />
          );
        },
        setCellProps: () => ({
          style: { minWidth: "150px" },
        }),
      },
    },
    {
      name: "category",
      label: "Kategori*",
      options: {
        customBodyRender: (val, tableMeta) => {
          const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
          return isSaved ? (
            <p>{val?.label}</p>
          ) : (
            <SimpleDDL
              id={`select_options_category_${tableMeta.rowIndex}`}
              containerclassname="margin-bottom-none width width-200px"
              name="category"
              box="search"
              menuPosition="fixed"
              value={val}
              options={dataKategori.map((item) =>
                mapToObjectDDL(item.label, item.value)
              )}
              onChange={(value, { name }) =>
                handleItemChange(tableMeta.rowIndex, name, value)
              }
            />
          );
        },
        sort: false,
      },
    },
    {
      name: "subGroup",
      label: "SubGroup*",
      options: {
        customBodyRender: (val, tableMeta) => {
          const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
          return isSaved ? (
            <p>{val?.label}</p>
          ) : (
            <SimpleDDL
              id={`select_options_subgroup_${tableMeta.rowIndex}`}
              containerclassname="margin-bottom-none width width-200px"
              name="subGroup"
              box="search"
              menuPosition="fixed"
              value={val}
              options={dataSubgoup.map((item) =>
                mapToObjectDDL(item.value, item.key)
              )}
              onChange={(value, { name }) =>
                handleItemChange(tableMeta.rowIndex, name, value)
              }
            />
          );
        },
        sort: false,
      },
    },
    {
      name: "group",
      label: "Group*",
      options: {
        customBodyRender: (val, tableMeta) => {
          const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
          return isSaved ? (
            <p>{val?.label}</p>
          ) : (
            <SimpleDDL
              id={`select_options_group_${tableMeta.rowIndex}`}
              containerclassname="margin-bottom-none width width-200px"
              name="group"
              box="search"
              menuPosition="fixed"
              value={val}
              options={dataGroup.map((item) =>
                mapToObjectDDL(item.value, item.key)
              )}
              onChange={(value, { name }) =>
                handleItemChange(tableMeta.rowIndex, name, value)
              }
            />
          );
        },
        sort: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        display: false,
      },
    },
    {
      name: "isNew",
      options: {
        display: false,
      },
    },
    {
      name: "saved",
      label: "Aksi",
      options: {
        customBodyRender: (val, tableMeta) => {
          const rowIndex = tableMeta.rowIndex;
          const rowData = tableMeta.rowData;
          const status = rowData[6] || "ACTIVE"; 
          const isNew = rowData[7]; 

          return (
            <FlexView vAlignContent="center" style={{ gap: 10 }}>
              <ToggleButton
                value={status === "ACTIVE"}
                onToggle={() =>
                  handleToggleClick(
                    rowIndex,
                    status === "ACTIVE" ? "INACTIVE" : "ACTIVE"
                  )
                }
                colors={{
                  active: { base: "rgb(76, 217, 100)" },
                  inactive: { base: "rgb(255, 59, 48)" },
                }}
                thumbStyle={{ borderRadius: 50 }}
                trackStyle={{ borderRadius: 50 }}
              />

              {val ? (
                <SimpleButton
                  category="action_button"
                  style={{ backgroundColor: "transparent" }}
                  icon={
                    <i
                      className="fa fa-pencil-alt"
                      style={{ fontSize: 20, color: "red" }}
                    />
                  }
                  onClick={() => handleEditRow(rowIndex)}
                />
              ) : (
                <SimpleButton
                  category="action_button"
                  style={{ backgroundColor: "transparent" }}
                  icon={
                    <i
                      className="fa fa-save"
                      style={{ fontSize: 20, color: "red" }}
                    />
                  }
                  onClick={() => handleSaveRow(rowIndex)}
                />
              )}

              <SimpleButton
                category="action_button"
                style={{ backgroundColor: "transparent" }}
                icon={
                  <i
                    className="fa fa-trash"
                    style={{ fontSize: 20, color: "red" }}
                  />
                }
                onClick={() => handleDeleteRow(rowIndex)}
              />
            </FlexView>
          );
        },
        sort: false,
      },
    },
  ];
};
